import { Link } from "react-router-dom";
import { Phone, Droplets } from "lucide-react";
import { PHONE, PHONE_TEL } from "@/lib/api";
import { COMPANY } from "@/lib/company";

export const Footer = () => {
  return (
    <footer data-testid="site-footer">
      {/* Yellow call strip */}
      <div className="bg-gold">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-5 text-center md:text-left">
            <div className="flex items-center gap-3">
              <span className="bg-navy rounded-full p-3">
                <Phone className="h-6 w-6 text-gold" />
              </span>
              <div>
                <p className="font-display font-extrabold text-navy text-sm tracking-wide">COMANDĂ ACUM TELEFONIC!</p>
                <p className="font-display font-black text-navy text-2xl leading-tight">{PHONE}</p>
              </div>
            </div>
            <div className="hidden md:block text-center">
              <p className="font-display font-extrabold text-navy text-lg">COMANDĂ RAPID</p>
              <p className="text-navy/80 text-sm">în doar câteva minute!</p>
            </div>
            <a
              href={PHONE_TEL}
              className="bg-navy hover:bg-navy-700 text-white font-display font-black px-8 py-3.5 rounded-full inline-flex items-center gap-2 transition-colors"
              data-testid="footer-call-button"
            >
              <Phone className="h-5 w-5" /> SUNĂ ACUM!
            </a>
          </div>
        </div>
      </div>

      {/* Navy footer */}
      <div className="bg-navy text-white/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="bg-eco rounded-xl p-2"><Droplets className="h-6 w-6 text-white" /></span>
              <span className="leading-none">
                <span className="block font-display font-black text-xl text-white">DETER<span className="text-eco">SHOP</span></span>
              </span>
            </div>
            <p className="text-sm leading-relaxed">
              Detergenți lichizi concentrați, la un preț corect. Curățenie profesională, rezultate impecabile.
            </p>
          </div>
          <div>
            <h4 className="font-display font-bold text-white mb-4">Navigare</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-gold">Acasă</Link></li>
              <li><Link to="/produse" className="hover:text-gold">Produse</Link></li>
              <li><Link to="/despre" className="hover:text-gold">Despre noi</Link></li>
              <li><Link to="/contact" className="hover:text-gold">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display font-bold text-white mb-4">Informații legale</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/termeni-si-conditii" className="hover:text-gold" data-testid="footer-terms">Termeni și condiții</Link></li>
              <li><Link to="/politica-de-confidentialitate" className="hover:text-gold" data-testid="footer-privacy">Politica de confidențialitate</Link></li>
              <li><Link to="/politica-de-cookies" className="hover:text-gold" data-testid="footer-cookies">Politica de cookies</Link></li>
              <li><Link to="/politica-de-retur" className="hover:text-gold" data-testid="footer-returns">Politica de retur</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display font-bold text-white mb-4">Date firmă</h4>
            <ul className="space-y-1.5 text-sm">
              <li className="text-white font-bold">{COMPANY.legalName}</li>
              <li>CUI: {COMPANY.cui}</li>
              <li>Nr. înreg.: {COMPANY.regNo}</li>
              <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-gold" /> {COMPANY.phone}</li>
              <li>{COMPANY.email}</li>
            </ul>
          </div>
        </div>

        {/* ANPC logos */}
        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-center gap-4" data-testid="anpc-logos">
            <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer nofollow" aria-label="ANPC SAL">
              <img
                src="https://etamade-com.github.io/anpc-sal-sol-logo/anpc-sal.svg"
                alt="ANPC - Soluționarea Alternativă a Litigiilor"
                style={{ width: "250px", maxWidth: "100%" }}
                data-testid="anpc-sal"
              />
            </a>
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer nofollow" aria-label="ANPC SOL">
              <img
                src="https://etamade-com.github.io/anpc-sal-sol-logo/anpc-sol.svg"
                alt="Soluționarea Online a Litigiilor"
                style={{ width: "250px", maxWidth: "100%" }}
                data-testid="anpc-sol"
              />
            </a>
          </div>
        </div>

        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 text-xs text-white/50 text-center">
            © {new Date().getFullYear()} {COMPANY.brand} — {COMPANY.legalName}. Toate drepturile rezervate.
          </div>
        </div>
      </div>
    </footer>
  );
};
